import {useMutation} from "@tanstack/react-query";
import {createCustomerOfferRevisionMutationOptions} from "./create-customer-offer-revision.mutation-options";

export function useCreateCustomerOfferRevision() {
  return useMutation(createCustomerOfferRevisionMutationOptions());
}
